import React from 'react';

import RowTemplate from './RowTemplate.tsx';
// import fullData from '../../data/line_top_landings.json';
import { SubAccount, ClientsAPI } from 'src/api'

// const years = ['2010', '2011', '2012'];

type fullData = Array<{
  path: string,
  info: Array<{
    sessions: number,
    period: number
  }>
}>
type Props = {
  client?: SubAccount
}

class LineTopLandingPages extends React.Component<Props>{
  state = {
    data: undefined,
    narrative: undefined
  }
  fetchData = (client: SubAccount) => {
    // const params = {
    //   narrative_assembly_id: "3870d92a-e82c-11ea-86cf-0e95a518f8f7",
    //   report_content_id: "16ce3654-efc5-11ea-86cf-0e95a518f8f7",
    //   sub_account_id: client.id,
    //   period_index: "1449",
    //   period_type: "monthly"
    // }

    ClientsAPI.getReportData(client, 'line_top_landings.json').then(result => {
      // console.log('done', result)
      this.setState({ data: result.data });
    }).catch(error => {
      // console.log('error', error)
    })

    // ClientsAPI.getNarrative(client, params).then(result => {
    //   // console.log('done', result)
    //   this.setState({ narrative: result[0] });
    // }).catch(error => {
    //   // console.log('error', error)
    // })
  }
  getPath(data: fullData) {
    const pathList: string[] = []
    const result = data.map((d, i) => {
      pathList.push(d.path)
    })

    return pathList
  }
  fillPeriod(data: fullData|any) {

    const MaxPeriodforEachLanding = data.map((d: { info: any[]; }, i: any) => {
      return Math.max.apply(Math, d.info.map(function (o) { return o.period; }))
    })
    const latesdPeriod = Math.max(...MaxPeriodforEachLanding)

    const minPeriodforEachLanding = data.map((d: { info: { period: any; }[]; }, i: any) => {
      return Math.min.apply(Math, d.info.map(function (o: { period: any; }) { return o.period; }))
    })
    const oldestPeriod = Math.min(...minPeriodforEachLanding)

    data.forEach((d: { info: { sessions: number; period: any; }[]; }) => {
      let maxPeriod = Math.max.apply(Math, d.info.map(function (o: { period: any; }) { return o.period; }))
      for (let i = 0; maxPeriod < latesdPeriod; i++) {
        d.info.push({
          sessions: 0,
          period: maxPeriod + 1
        })
        maxPeriod += 1
      }
      let minPeriod = Math.min.apply(Math, d.info.map(function (o: { period: any; }) { return o.period; }))
      for (let i = 0; minPeriod > oldestPeriod; i++) {
        d.info.push({
          sessions: 0,
          period: minPeriod - 1
        })
        minPeriod -= 1
      }
    });
    return data

  }

  // console.log(fillPeriod(fullData))
  render() {
    const { data, narrative } = this.state
    const { client } = this.props;
    if (!data && client) {
      this.fetchData(client);
    }

    if (!data) return null;

    return (

      <React.Fragment>

        <h3 className="long-title">Top Landing Pages for Organic Search</h3>
        <div id="chart-demo">
          <table className="demo-table">
            <tbody>
              <tr>
                <th />
                <th style={{ width: 200, textAlign: 'center' }}>Landing Pages Trend Line</th>
              </tr>
              {
                this.fillPeriod(data).map((data: any) => {
                  return <RowTemplate data={data} />;
                })
              }
            </tbody>
          </table>
        </div>
      </React.Fragment>
    );
  }
}
export default LineTopLandingPages;


// WEBPACK FOOTER //
// ./src/components/ReportComponents/LineTopLandingPages.tsx